import { defineMessages } from 'react-intl'

export const checkoutAmountMessages = defineMessages({
  taxesIncluded: {
    id: 'checkout.taxesIncluded',
    description:
      'Message telling the user that extra taxes might be charged during Stripe checkout',
    defaultMessage: '+ State & Local Taxes will be calculated after checkout',
  },
  subtotal: {
    id: 'checkout.subtotal',
    description: 'Checkout row text describing subtotal amount',
    defaultMessage: 'Subtotal',
  },
  startingBalance: {
    id: 'checkout.startingBalance',
    description:
      'Checkout row text describing the balance user has for the moment',
    defaultMessage: 'Starting Balance',
  },
  endingBalance: {
    id: 'checkout.endingBalance',
    description:
      'Checkout row text describing balance user will have after proceeding current checkout',
    defaultMessage: 'Ending Balance',
  },
  discount: {
    id: 'checkout.discount',
    description: 'Checkout row text describing discount amount',
    defaultMessage: 'Discount',
  },
  taxes: {
    id: 'checkout.taxes',
    description: 'Checkout row text describing taxes amount',
    defaultMessage: 'Taxes',
  },
  amountToPay: {
    id: 'checkout.amountToPay',
    description:
      'Checkout row text describing how much user will have to pay (or $0)',
    defaultMessage: 'Amount Due Today',
  },
})
